import ConfirmChallengeMethodScreen from 'features/auth/verifyAddressChange/screens/ConfirmChallengeMethodScreen/ConfirmChallengeMethodScreen';
import React from 'react';

export default function Page() {
  return <ConfirmChallengeMethodScreen />;
}
